import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    Data: { data: [] },
    Date: '',
    DDLEmployee: [],
    EmployeeLogType: [],
    EmployeeLogSeverity: [],
};

export const systemLogReducer = createSlice({
    name: "systemLogReducer",
    initialState,
    reducers: {
        resetSystemReducer: (state) => {
            state.Data.data = [];
        },
        setSystemLogReducer: (state, action) => {
            state.Data = action.payload;
        },
        setSystemLogDate: (state, action) => {
            state.Date = action.payload;
        },
        setSystemLogDDLEmployee: (state, action) => {
            state.DDLEmployee = action.payload;
        },
        setSystemLogDDLEmployeeLogType: (state, action) => {
            state.EmployeeLogType = action.payload;
        },
        setSystemLogDDLEmployeeLogSeverity: (state, action) => {
            state.EmployeeLogSeverity = action.payload;
        },
    },
});

export const {
    setSystemLogReducer,
    setSystemLogDate,
    setSystemLogDDLEmployee,
    setSystemLogDDLEmployeeLogType,
    setSystemLogDDLEmployeeLogSeverity,
    resetSystemReducer,
} = systemLogReducer.actions;

export default systemLogReducer.reducer;
